import axios from 'axios';
import { environment } from '../environment/environment';
import { returnBaseUrl } from '../utils/baseURL';

export const useApiClient = () => {
  const portaBackEnd = process.env.REACT_APP_PORTA_BACKEND ?? '8080';
  const isBackEndLocal = process.env.REACT_APP_BACK_END_LOCAL ?? 'false';

  const SITE_ENVIRONMENT = environment.environment;
  let BACK_END_ENVIRONMENT;
  if (isBackEndLocal === 'true') {
    BACK_END_ENVIRONMENT = 'local';
  } else if (SITE_ENVIRONMENT === 'local') {
    BACK_END_ENVIRONMENT = 'des';
  } else {
    BACK_END_ENVIRONMENT = SITE_ENVIRONMENT;
  }
  const SITE_BASE_URL = returnBaseUrl(BACK_END_ENVIRONMENT, portaBackEnd);

  const httpCall = axios.create({
    baseURL: SITE_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
  });

  return httpCall;
};
